export default __webpack_public_path__ + "static/media/verified.6f298cca.png";